<script setup>
import {useMutation} from "@vue/apollo-composable";

import {ref} from "vue";
import TicPatientStrip from "./TicPatientStrip.vue";
import DestinationHospitalModal from "../DestinationHospitalModal.vue";
import {HpoPatientTransportReplyMutation} from "@/graphql/mutations/hpo/patient/transportReply.graphql"
import {HpoSetPatientInHospitalMutation} from "@/graphql/mutations/hpo/patient/setPatientInHospital.graphql"
import {HpoSetDestinationHospitalMutation} from "@/graphql/mutations/hpo/patient/transportDestination.graphql"
import TicPatientMobileCard from "./TicPatientMobileCard.vue";
import {lg} from "../../../../utils/breakpoints";
import {mdiMagnify} from "@mdi/js";
import {gettext} from "../../../../utils/translate";


const props = defineProps({
  hpo: {
    type: Object,
    required: true
  },
  member: {
    type: Object,
    required: true
  },
  anyLoading: {
    type: Boolean,
    required: true
  },
  hospitalList: {
    type: Object,
    required: true
  },
  patientList: {
    type: Array,
    required: true
  },
  alertList: {
    type: Array,
    required: true
  },
  now: {
    type: Object,
    required: true
  }
})
const emit = defineEmits(['openReplyModal', 'displayActionsModal'])


const editedTransportData = ref(null)


const {mutate} = useMutation(HpoPatientTransportReplyMutation)
const {mutate: setPatientInHospitalMutation} = useMutation(HpoSetPatientInHospitalMutation)
const {mutate: hpoSetDestinationHospital} = useMutation(HpoSetDestinationHospitalMutation);


function handleDisplayActionsModal(patient) {
  emit('displayActionsModal', patient)
}

function handleOpenReplyModal(reply, patient) {
  emit('openReplyModal', reply, patient)
}

function handleSetEditedTransportData(patient) {
  editedTransportData.value = patient
}


</script>

<template>
  <v-empty-state v-if="patientList.length === 0"
                 :icon="mdiMagnify"
                 :title="gettext('No patients found')">
  </v-empty-state>


  <template v-if="lg">
    <v-table v-if="patientList.length > 0"
             density="compact"
             :fixed-header="true"
             :hover="true"
             id="tic-patient-list-table"
    >
      <thead>
      <tr>
        <th>{{ pgettext('label', 'Actions') }}</th>
        <th>{{ pgettext('label', 'TIC Card Number') }}</th>
        <th>{{ pgettext('label', 'Gender') }}</th>
        <th>{{ pgettext('label', 'Transport Priority') }}</th>
        <th>{{ pgettext('label', 'Diagnose') }}</th>
        <th>{{ pgettext('label', 'ALV') }}</th>
        <th>{{ pgettext('label', 'Unit Type') }}</th>
        <th>{{ pgettext('label', 'Call Sign / LP') }}</th>
        <th>{{ pgettext('label', 'Hospital Type') }}</th>
        <th>{{ pgettext('label', 'Destination Hospital') }}</th>
        <th>{{ pgettext('label', 'Transport status') }}</th>
      </tr>
      </thead>
      <tbody>
      <TicPatientStrip v-for="patient in patientList"
                       :key="patient.id"
                       :patient="patient"
                       :member="member"
                       :alertList="alertList"
                       :now="now"
                       @displayActionsModal="handleDisplayActionsModal"
                       @setEditedTransportData="handleSetEditedTransportData"
                       @openReplyModal="handleOpenReplyModal"/>
      </tbody>
    </v-table>
  </template>
  <template v-else>
    <TicPatientMobileCard v-for="patient in patientList"
                          :patient="patient"
                          :member="member"
                          :now="now"
                          :alertList="alertList"
                          @displayActionsModal="handleDisplayActionsModal"
                          @setEditedTransportData="handleSetEditedTransportData"
                          @openReplyModal="handleOpenReplyModal"
    />
  </template>


  <DestinationHospitalModal v-if="editedTransportData"
                            :patient="editedTransportData"
                            :hospitalList="hospitalList"
                            @close="editedTransportData=null"/>
</template>

<style scoped>
th {
  padding: 0 2px !important;
  text-align: center !important;
}
</style>